module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tile": "",
      "hover": ""
    }
  }, [_c('playlist-teaser-image', {
    attrs: {
      "playlist": _vm.playlist
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'Playlist',
        params: {
          id: _vm.playlist.id
        }
      }
    }
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('h4', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(_vm.playlist.title))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3df983e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaylistTeaser.vue
// module id = 356
// module chunks = 0